const notEditableReportsIds = ['byDayReport', 'byTouchReport'];
export default notEditableReportsIds;
